import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Get the selected option from localStorage or default to aggregated
        const selectedOption = localStorage.getItem('selectedOption') || 'Aggregated';
        const method = selectedOption.toLowerCase();

        // Redirect to the analytics page by default
        navigate(`/dashboard/${method}/analytics`, { replace: true });
    }, [navigate]);

    return null; // This component doesn't render anything
};

export default DashboardRedirect; 